var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo-image",attrs:{"src":_vm.$vuetify.theme.dark ? 'img/full-white-medium.png':'img/full-black-medium.png',"alt":"logo image"}}),_c('span',[_vm._v(" Vue Music ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }